
export * from '../../frontend-js-components-web/__liferay__/index.js';
